import { Controller } from "stimulus";

const ICONS = { rush: "forward", firm: "thumbtack" };

const ROW_CLASSES = {
  rush: "bg-rose-100! text-red-700! [&.select2-results__option--highlighted]:bg-rose-200! [&.select2-results__option--highlighted]:text-red-700!",
  firm: "bg-amber-50! text-amber-700! [&.select2-results__option--highlighted]:bg-amber-100! [&.select2-results__option--highlighted]:text-amber-700!",
};

const TRIGGER_BOX_CLASSES = {
  rush: "bg-rose-100! border-red-700!",
  firm: "bg-amber-50! border-amber-600!",
};

const TRIGGER_TEXT_CLASSES = {
  rush: "text-red-700!",
  firm: "text-amber-700!",
};

export default class extends Controller {
  connect() {
    $(this.element)
      .select2({
        minimumResultsForSearch: -1,
        width: "",
        templateResult: (option, container) => this.renderOption(option, container),
        templateSelection: (option) => this.renderOption(option),
      })
      .on("change", () => this.applyTriggerState());

    $(this.element).next(".select2-container").find(".select2-selection__rendered").addClass("flex! items-center!");

    this.applyTriggerState();
  }

  disconnect() {
    $(this.element).select2("destroy");
  }

  renderOption(option, container) {
    if (!option.id) return option.text;

    if (container && ROW_CLASSES[option.id]) $(container).addClass(ROW_CLASSES[option.id]);

    const $row = $('<span class="inline-flex items-center gap-1.5"></span>');

    if (ICONS[option.id]) {
      $row.append(`<i class="fas fa-${ICONS[option.id]}"></i>`);
    }

    $row.append(document.createTextNode(option.text));

    return $row;
  }

  applyTriggerState() {
    const $container = $(this.element).next(".select2-container");
    const $selection = $container.find(".select2-selection");
    const $rendered = $container.find(".select2-selection__rendered");
    const value = $(this.element).val();

    Object.values(TRIGGER_BOX_CLASSES).forEach((cls) => $selection.removeClass(cls));
    Object.values(TRIGGER_TEXT_CLASSES).forEach((cls) => $rendered.removeClass(cls));

    if (TRIGGER_BOX_CLASSES[value]) $selection.addClass(TRIGGER_BOX_CLASSES[value]);
    if (TRIGGER_TEXT_CLASSES[value]) $rendered.addClass(TRIGGER_TEXT_CLASSES[value]);
  }
}
